export const ApiParam = {
    product_type: 'product_type',
    product_sub_type: 'product_sub_type',
    dealer_location:'dealer_location',
    keyword: 'query',
};
